import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  ds_titulo: Yup.string().trim().required("O campo título é obrigatório."),
  ds_descricao: Yup.string()
    .trim()
    .required("O campo descrição é obrigatório."),
});
